import { Browser } from '@capacitor/browser';

export const navigateReactUrl = (initPath: any, path: any) => {
    if ((window as any).cordova) 
        return  Browser.open({ url: `${initPath}${path}` });
    else
        return window.open(`${initPath}${path}`, '_self')
}